import { render, staticRenderFns } from "./AmTextArea.vue?vue&type=template&id=051a78b1&scoped=true&"
import script from "./AmTextArea.vue?vue&type=script&lang=js&"
export * from "./AmTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a78b1",
  null
  
)

export default component.exports